import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'saLogPipe'
})
export class SaLogPipePipe implements PipeTransform {

  transform(LogData: any[], searchTermLog: string): any[] {
    if (!LogData || !searchTermLog) { return LogData; }

    LogData.forEach(element => {
      if(element.LicenseNo==null ){
        element.LicenseNo="";
      }
      if(element.Types==null ){
        element.Types="";
      }
    });
   

    return LogData.filter(ad =>
     
    
      ad.LicenseNo.toLowerCase().indexOf(searchTermLog.toLowerCase().trim()) !== -1
      ||
      ad.Types.toLowerCase().indexOf(searchTermLog.toLowerCase().trim())!==-1
   


    );
  }
//searchTermLog
}
